<template>
  <div class="login">
    <div class="row justify-content-center mt-5 pt-5">
      <div class="col-md-12 mb-5 text-center">
        <img :src="preferences.data.avatar" height="80" alt="">
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-md-6 mx-auto">
        <div class="card p-5">
          <h1 class="">Redefinir Senha</h1>
          <hr>
          <form @submit.prevent="reset(user)">
            <div class="form-group">
              <label for="email" class="control-label">E-mail:</label>
              <input v-model="user.email" disabled type="email" class="form-control" placeholder="Digite seu email" required>
            </div>
            <div class="form-group">
              <label for="password" class="control-label">Senha:</label>
              <input v-model="user.password" type="password" class="form-control" placeholder="Digite sua senha" required>
            </div>
            <div class="form-group">
              <label for="password_confirm" class="control-label">Confirmar Senha:</label>
              <input v-model="user.password_confirm" type="password" class="form-control" placeholder="Confirme sua senha" required>
            </div>
            <button class="btn btn-success w-100 py-3">
              Entrar
            </button>
          </form>
        </div>
      </div>
    </div>
    <LoadingComponent :loading="auth.loading" />
  </div>
</template>

<script>

import { mapState, mapActions } from 'vuex'
import LoadingComponent from '../../components/layout/LoadingComponent'

export default {

  name: 'LoginPage',

  components: {
    LoadingComponent
  },

  data () {
    return {
      user: {
        token: null,
        email: null,
        password: null,
        password_confirm: null
      }
    }
  },

  computed: mapState({
    preferences: state => state.preferences,
    auth: state => state.auth
  }),

  methods: {

    ...mapActions('auth', [
      'reset'
    ])

  },

  mounted () {
    this.user.email = this.$route.query.email
    this.user.token = this.$route.query.token
  }

}

</script>
